import { useState } from 'react';
import PropTypes from 'prop-types';
// MATERIAL IMPORTS
import { Box, IconButton, TableRow, TableCell, TableHead, Tooltip, tableCellClasses, Typography, TableSortLabel } from '@material-ui/core';
import { visuallyHidden } from '@material-ui/utils';
import { ArrowUpward, ArrowDownward, SwapVert } from '@material-ui/icons';

// ----------------------------------------------------------------------


export default function SortingSelectingEmpDashHeadScore({
    order,
    orderBy,
    headLabel,
    onRequestSort,
}) {

    // LOCAL STORAGE
    const loggedUserData = JSON.parse(window.localStorage.getItem('userData'));

    const [showIcon, setShowIcon] = useState(false);

    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow sx={{
                [`& .${tableCellClasses.root}`]: {
                    py: { lg: 0.6, xl: 1 },
                },
            }}>
                {headLabel.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        sx={{ px: 1, margin: "0 auto", minWidth: headCell.id === 'id' ? '95px' : '0px' }}
                        padding={headCell.disablePadding ? 'none' : 'normal'} >


                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            sx={{ pl: headCell.align === 'left' ? 1 : 3 }}
                        >
                            <Typography variant='tableHead'>
                                {headCell?.label}
                            </Typography>
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={{ ...visuallyHidden }}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>

                ))}
            </TableRow>
        </TableHead>
    );
}
